export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";